import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`user/dashboard?${query}`)
  }
}

export default DashboardService
